export default __webpack_public_path__ + "static/media/mug.fdd4f49f.jpg";